import ben from '../../assets/ben.png';
import grace from '../../assets/grace.png';
import allison from '../../assets/allison.png';

export const panelistData = [
  {
    name: 'Ben',
    photo: ben,
    caption: 'A 41-year-old technology professional in New York City, living with TRD.'
  },
  {
    name: 'Grace',
    photo: grace,
    caption: 'A 33-year-old non-profit coordinator in Colorado, living with TRD.'
  },
  {
    name: 'Allison',
    photo: allison,
    caption:
      'A 48-year-old mother of five in rural Kentucky and the caregiver of her son Austin, who lives with TRD.'
  }
];
